import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export const Layout = ({ children }) => (
  <div className="App flex flex-col min-h-screen">
    <Header />
    <main className="flex-1 pt-16 lg:pt-20">{children}</main>
    <Footer />
    <CookieBanner />
  </div>
);
